import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import StyledProgress, { Bar } from "./StyledProgress";
import ProgressBunnyWrapper from "./ProgressBunnyWrapper";
import { ProgressBunny } from "../Svg";
import { variants, scales } from "./types";
var stepGuard = function(step) {
    if (step < 0) {
        return 0;
    }
    if (step > 100) {
        return 100;
    }
    return step;
};
var Progress = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? variants.ROUND : _variant, _scale = param.scale, scale = _scale === void 0 ? scales.MD : _scale, _primaryStep = param.primaryStep, primaryStep = _primaryStep === void 0 ? 0 : _primaryStep, _secondaryStep = param.secondaryStep, secondaryStep = _secondaryStep === void 0 ? null : _secondaryStep, _showProgressBunny = param.showProgressBunny, showProgressBunny = _showProgressBunny === void 0 ? false : _showProgressBunny, _useDark = param.useDark, useDark = _useDark === void 0 ? true : _useDark, children = param.children;
    return /*#__PURE__*/ _jsx(StyledProgress, {
        $useDark: useDark,
        variant: variant,
        scale: scale,
        children: children || /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                showProgressBunny && /*#__PURE__*/ _jsx(ProgressBunnyWrapper, {
                    style: {
                        left: "".concat(stepGuard(primaryStep), "%")
                    },
                    children: /*#__PURE__*/ _jsx(ProgressBunny, {})
                }),
                /*#__PURE__*/ _jsx(Bar, {
                    $useDark: useDark,
                    primary: true,
                    style: {
                        width: "".concat(stepGuard(primaryStep), "%")
                    }
                }),
                secondaryStep ? /*#__PURE__*/ _jsx(Bar, {
                    $useDark: useDark,
                    style: {
                        width: "".concat(stepGuard(secondaryStep), "%")
                    }
                }) : null
            ]
        })
    });
};
export default Progress;
